import styled from 'styled-components'

export const PageTitle = styled.h5`
  font-family: "Roboto Mono", monospace;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
`
